module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getContainerStyle),
    attrs: {
      "id": "timelineContainer"
    },
    on: {
      "!keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.stopDragging()
      },
      "dragover": function($event) {
        _vm.dragoverHandler($event)
      },
      "!drop": function($event) {
        _vm.dropHandler($event)
      }
    }
  }, [_vm._l((_vm.$store.state.timeScaleTicks), function(tick, index) {
    return _c('div', {
      staticClass: "tlTicksCells",
      class: _vm.getTicksClass(index),
      style: (_vm.tlTicksStyle)
    })
  }), _vm._v(" "), _vm._l((_vm.classroomNames), function(classroom) {
    return _c('timeline', {
      key: classroom,
      attrs: {
        "classroom": classroom,
        "dragging": _vm.hasDraggingTl
      },
      on: {
        "tlmousedown": _vm.mousedownHandler,
        "tlmousemove": _vm.mousemoveHandler,
        "tlmouseup": _vm.mouseupHandler
      }
    })
  }), _vm._v(" "), _vm._l((_vm.filteredreservation), function(r) {
    return _c('reservation-box', {
      key: r.id,
      attrs: {
        "reservation": r
      },
      on: {
        "pvmousedown": _vm.mousedownHandler,
        "pvmousemove": _vm.mousemoveHandler
      }
    })
  }), _vm._v(" "), _c('preview-box', {
    attrs: {
      "dragging": _vm.hasDraggingTl
    },
    on: {
      "pvmousedown": _vm.mousedownHandler,
      "pvmousemove": _vm.mousemoveHandler,
      "pvmouseup": _vm.mouseupHandler,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.stopDragging()
      }
    }
  }), _vm._v(" "), (_vm.$store.state.previewBox.isPopupShown &&
    _vm.$store.state.previewBox.style.height !== 0) ? _c('reservation-popup') : _vm._e(), _vm._v(" "), _c('editing-box'), _vm._v(" "), _c('editing-popup'), _vm._v(" "), _c('information-popup')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a71e8d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/TimelineContainer.vue
// module id = 715
// module chunks = 0